<template>
    <div>
        <el-collapse v-model="activeNames" @change="handleChange" class="bg-transparent">
            <el-collapse-item name="1">
                <template #title>
                    <div class="custom-title w-full">
                        <span class="text-base">Sender</span>
                    </div>
                </template>
                <Sender ref="senderComponent" />
            </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="activeReciever" @change="handleChange" class="bg-transparent">
            <el-collapse-item name="1">
                <template #title>
                    <div class="custom-title w-full">
                        <span class="text-base">Receiver</span>
                    </div>
                </template>
                <Reciever ref="recieverComponent" />
            </el-collapse-item>
        </el-collapse>
        <el-collapse v-model="activeDetails" @change="handleChange" class="bg-transparent">
            <el-collapse-item name="1">
                <template #title>
                    <div class="custom-title w-full">
                        <span class="text-base flex items-center">Return Details <span class="opacity-50 mr-2 ml-1">
                                (Optional)</span>
                            <el-tooltip
                                content="You can skip return details. However, if a return occurs, charges will apply based on MuleEx's return policy."
                                placement="top">
                                <span>
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M8.8 5.6H7.2V4H8.8V5.6ZM8.8 12H7.2V7.2H8.8V12ZM8 0C6.94943 0 5.90914 0.206926 4.93853 0.608964C3.96793 1.011 3.08601 1.60028 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.08601 14.3997 3.96793 14.989 4.93853 15.391C5.90914 15.7931 6.94943 16 8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 6.94943 15.7931 5.90914 15.391 4.93853C14.989 3.96793 14.3997 3.08601 13.6569 2.34315C12.914 1.60028 12.0321 1.011 11.0615 0.608964C10.0909 0.206926 9.05058 0 8 0Z"
                                            fill="#383F51" />
                                    </svg>
                                </span>
                            </el-tooltip>
                        </span>
                    </div>
                </template>
                <ReturnAddress />
            </el-collapse-item>
        </el-collapse>

        <NoShippingServiceModal :show-modal="showNoShippingService" @closeModal="showNoShippingService = false" />


        <div class="flex w-full items-center justify-end py-4 px-4">
            <button class="underline mr-5" @click="$router.go(-1)">
                Back
            </button>
            <primary-button class="shadow-md font-normal" buttonText="Continue" :loading="isLoading" :disabled="false"
                @click="saveUserInfo" />
        </div>
    </div>
</template>

<script>
import Sender from "./Sender.vue";
import Reciever from "./Reciever.vue";
import ReturnAddress from "./module/components/ReturnAddress.vue";
import NoShippingServiceModal from "./modals/no-shipping-service-modal.vue"

export default {
    components: {
        Sender,
        Reciever,
        ReturnAddress,
        NoShippingServiceModal
    },
    data() {
        return {
            activeNames: "0",
            activeReciever: "0",
            activeDetails: "0",
            isLoading: false,
            showNoShippingService: false
        };
    },
    watch: {
    },

    mounted() {
        this.noMethodReroute()
        setTimeout(() => {
            this.activeNames = "1"
        }, 500)
    },
    computed: {
        getShipmentType() {
            const senderState = this.$store.getters?.getSavedNewSender?.address?.state?.toLowerCase()?.trim().replace(" State", '');
            const receivers = this.$store.getters?.getSavedNewRecievers || [];

            const allMatch = receivers.every((receiver) => {
                const receiverState = receiver?.address?.state
                    ?.toLowerCase()
                    ?.trim()
                    .replace(" State", "");

                return receiverState === senderState;
            });

            const shipmentType = allMatch ? "intra" : "inter";
            this.$store.dispatch("setNewBookingIsInterState", !allMatch);
            return shipmentType;
        }
    },
    methods: {
        payload() {
            const recievers_ = this.$store.getters?.getSavedNewRecievers.map((reciever) => {
                return {
                    lat: reciever?.address?.lat,
                    lng: reciever?.address?.lng,
                    address: reciever?.address?.name
                }
            })
            return {
                shipmentType: this.getShipmentType.toUpperCase(),
                sender: {
                    lat: this.$store.getters?.getSavedNewSender?.address?.lat,
                    lng: this.$store.getters?.getSavedNewSender?.address?.lng
                },
                receivers: recievers_
            }
        },
        noMethodReroute() {
            const routeTo = this.$_3pl ? "/3pl/dashboard" : "/active-bookings"
            if (this.$store.getters.getNewBookingShippingMethod == "") {
                this.$router.push(routeTo)
            }
        },
        handleChange() {
            // code to alert collapse changes
        },
        async checkForShippingService() {
            this.isLoading = true
            const sender = this.$store.getters?.getSavedNewSender;
            const recievers_ = this.$store.getters?.getSavedNewRecievers.map((reciever) => {
                return { ...reciever?.address }
            })
            const payload = {
                senderAddress: { ...sender?.address },
                receiverAddresses: recievers_,
                terminalType: this.$store.getters.getNewBookingShippingMethod
            }
            if(!this.$store.getters.getIsInterState){
                this.$store.dispatch('setSavedActiveTab', 2) 
                return
            }
            try {
                const response = await this.$_checkShippingService(payload);
                if (response?.data?.data?.canContinue) {
                    this.$store.dispatch('setSavedActiveTab', 2)
                    return;
                }
                this.showNoShippingService = true
            } catch (error) {
                // code here
            } finally {
                this.isLoading = false
            }
        },
        async getRecieversRestrictions() {
            this.isLoading = true
            try {
                let response = await this.$_getRecieverRestriction(this.payload());
                if (response?.data?.issues.length == 0) {
                    this.checkForShippingService()
                } else {
                    this.generateToast(response?.data?.message, "error")
                }
            } catch (error) {
                // error handling
            } finally {
                this.isLoading = false
            }
        },
        saveUserInfo() {
            const canPassSender = this.$refs.senderComponent.saveSenderTostore();
            const canPassReciever = this.$refs.recieverComponent.saveRecieverTostore();
            canPassSender && canPassReciever && this.getRecieversRestrictions()
        }
    },
    // setSavedNewSender 
}
</script>

<style lang="scss" scoped></style>